import React from "react";

export function InfoToast({message, title, subtitile}) {

    return (
        <div className="toast bg-info fade show" role="alert" aria-live="assertive" aria-atomic="true">
            <div className="toast-header"><strong className="mr-auto">{title}</strong><small>{subtitile}</small>
            </div>
            <div className="toast-body">{message}</div>
        </div>
    )
}